import { render, staticRenderFns } from "./commodityDialog.vue?vue&type=template&id=488aa70e&scoped=true"
import script from "./commodityDialog.vue?vue&type=script&lang=js"
export * from "./commodityDialog.vue?vue&type=script&lang=js"
import style0 from "./commodityDialog.vue?vue&type=style&index=0&id=488aa70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488aa70e",
  null
  
)

export default component.exports